<footer>
    <section class="container">
        <div class="footer-in">
            <p>© 2020 Copyright <a routerLink="/home">Magzter.com</a></p>
        </div>
    </section>
</footer>